
class Auth {
    constructor() {
        this.authenticated = false;
    }

    login(password, sucess, fail) {
        if (password === "accept") {
            this.authenticated = true;
            sucess();
        } else {
            fail()
        }
    }

    logout(cb) {
        this.authenticated = false;
        cb();
    }

    isAuthenticated() {
        return this.authenticated;
    }
}

export default new Auth();


// WEBPACK FOOTER //
// ./src/auth.js